// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"11020": "16fea115044d","18357": "70fb16f8c80d","31334": "6c9ac56ee65c","35545": "7ea9faf92a75","42530": "81999d02ec3f","53969": "bfc4bac31174","66863": "c939bdd77392","75434": "a5e0e99a2e5e",}[chunkId] + ".css"
}